import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
  name: 'resetMaxMin'
})
export class ResetMaxMinPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const quantity = Number(value);
    if (args >= 1 && args >= quantity) {
      return args;
    } else if (!args) {
      return quantity;
    } else {
      return quantity;
    }
  }

}
